var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConsumption(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 34,
    viewBox: "0 0 33 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.33337,
    y: 3,
    width: 28,
    height: 28,
    rx: 14,
    fill: "#FFA726"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2713 14.9396H18.3149C18.4596 14.9397 18.602 14.9757 18.7294 15.0444C18.8568 15.113 18.9651 15.2122 19.0448 15.333C19.1244 15.4538 19.1729 15.5925 19.1858 15.7366C19.1987 15.8807 19.1756 16.0258 19.1187 16.1588L16.8087 21.5505C16.753 21.6796 16.6544 21.7856 16.5297 21.8506C16.405 21.9156 16.2617 21.9356 16.1239 21.9073C15.9862 21.879 15.8624 21.8042 15.7733 21.6953C15.6843 21.5865 15.6355 21.4503 15.6351 21.3096V17.273L14.7875 17.2467C14.5605 17.2391 14.3454 17.1436 14.1875 16.9803C14.0297 16.8171 13.9415 16.5988 13.9417 16.3717V12.9166C13.9417 12.6846 14.0338 12.462 14.1979 12.2979C14.362 12.1338 14.5846 12.0416 14.8167 12.0416H16.3963C16.6284 12.0416 16.8509 12.1338 17.015 12.2979C17.1791 12.462 17.2713 12.6846 17.2713 12.9166V14.9396Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.33337,
    y: 3,
    width: 28,
    height: 28,
    rx: 14,
    stroke: "#FFF5E0",
    strokeWidth: 4.66667
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsumption);
export default __webpack_public_path__ + "static/media/consumption.6c2c04bcad18ff025abf376832ac0617.svg";
export { ForwardRef as ReactComponent };